import { generateFieldsByTableColumns } from '@/utils/functions'

/**
 * ============================================================================
 * CLIENTS-SPECIFIC HELPERS
 * Business logic specific to clients module
 * ============================================================================
 */

/**
 * Build clients query payload with filters and department
 */
export function buildClientsQueryPayload (searchFilters, additionalPayload, departmentId) {
	const variables = Object.keys(additionalPayload).length
		? Object.assign({}, searchFilters, additionalPayload)
		: { ...searchFilters }

	const payload = {}

	// Add department filter
	if (departmentId) {
		payload.departmentIds = departmentId
	}

	// Apply search filters
	if (Object.keys(variables).length) {
		Object.entries(variables).forEach(([key, value]) => {
			const shouldInclude = !Array.isArray(value) || value.length > 0
			if (value && shouldInclude) {
				payload[key] = value
			}
		})
	}

	return payload
}

/**
 * Build client orders payload with filters and pagination
 */
export function buildClientOrdersPayload (ordersSearchFilters, basePayload, page, size) {
	const query = {
		payload: basePayload,
		page,
		size
	}

	if (Object.keys(ordersSearchFilters).length) {
		const { page: _page, size: _size, ...filters } = ordersSearchFilters

		query.page = page || _page
		query.size = size || _size

		if (filters.ids) {
			query.payload.statuses = null
		}

		query.payload = {
			...query.payload,
			...filters
		}
	}

	return query
}

/**
 * Build columns from table state
 */
export function buildColumnsFromTable (tableState) {
	return generateFieldsByTableColumns(
		tableState.columns,
		tableState.originalColumns
	)
}

/**
 * Build search payload with company/department logic
 */
export function buildSearchPayload (searchPhrase, companyId, departmentId, selectedDepartmentId) {
	const payload = { searchPhrase }

	if (companyId) {
		payload.companyId = companyId
	} else if (departmentId) {
		payload.departmentId = departmentId
	} else if (selectedDepartmentId) {
		payload.departmentId = selectedDepartmentId
	}

	return payload
}
